import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useFormikContext } from 'formik';

import TextField from '../../fields/textField';
import Span from '../../../../components/Grid/Span';
import messages from '../messages';
import {
  getCountriesPhones,
  getFlagByCallingCode,
} from '../../common/CountrySelect/utils';
import SelectField from '../../fields/select';

export const propTypes = {
  currentStep: PropTypes.oneOf([
    'phone',
    'password',
    'otp',
    'createPassword',
    'confirm',
    'phoneReset',
    'otpReset',
    'resetConfirm',
    'notFound',
  ]).isRequired,
  state: PropTypes.shape({
    isNotRegistered: PropTypes.bool.isRequired,
    isNotValidFormat: PropTypes.bool.isRequired,
    updateTS: PropTypes.number,
  }).isRequired,
};

const PhoneFragment = ({ currentStep, state }) => {
  const { formatMessage } = useIntl();
  const { setFieldError } = useFormikContext();

  const countries = useMemo(getCountriesPhones, []);

  useEffect(() => {
    if (state.isNotValidFormat)
      setFieldError('phoneNumber', formatMessage(messages.phoneNotValid));
  }, [state.isNotValidFormat, state.updateTS]);

  const isDisabled =
    (currentStep !== 'phone' && currentStep !== 'phoneReset') ||
    state.isNotRegistered;

  if (['createPassword', 'confirm', 'resetConfirm'].includes(currentStep))
    return null;

  return (
    <>
      <Span xs={4}>
        <SelectField
          name="phoneNumberPrefix"
          options={countries}
          onChangeIconFn={getFlagByCallingCode}
          disabled={isDisabled}
        />
      </Span>
      <Span xs={7}>
        <TextField
          name="phoneNumber"
          type="text"
          filterPattern={/^[0-9]+$/}
          label={formatMessage(messages.phoneLabel)}
          autoFocus={!isDisabled}
          disabled={isDisabled}
          required
        />
      </Span>
    </>
  );
};

PhoneFragment.propTypes = propTypes;

export default PhoneFragment;
